import * as Sentry from "@sentry/react";
import { ComponentType, ReactNode } from "react";

import { DefaultErrorPage, THEME } from "./DefaultErrorPage";

type FallbackProps = {
  error: unknown;
  componentStack: string | null;
};

interface SentryErrorBoundaryProps {
  appName: string;
  theme?: THEME;
  FallbackComponent?: ComponentType<FallbackProps>;
  children: ReactNode;
}

export function SentryErrorBoundary({
  appName,
  theme,
  FallbackComponent,
  children,
}: SentryErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, componentStack, resetError }) =>
        FallbackComponent ? (
          <FallbackComponent error={error} componentStack={componentStack} />
        ) : (
          <DefaultErrorPage
            theme={theme}
            error={error}
            componentStack={componentStack ?? ""}
            resetError={resetError}
          />
        )
      }
      beforeCapture={(scope) => {
        scope.setTag("appName", appName);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
